import { createApp } from 'vue';
import { router } from '@/plugins/router';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import { createPinia } from 'pinia';

import ActivateForm from '@/components/ActivateForm/ActivateForm';
import ChangePasswordForm from '@/components/ChangePasswordForm/ChangePasswordForm';
import ForgotPasswordForm from '@/components/ForgotPasswordForm/ForgotPasswordForm';
import IDOverview from '@/components/IDOverview/IDOverview';
import PersonalProfile from '@/components/PersonalProfile/PersonalProfile';
import PolteqButton from '@/components/PolteqButton/PolteqButton';
import PolteqTextField from '@/components/PolteqTextField/PolteqTextField';
import ResetPasswordForm from '@/components/ResetPasswordForm/ResetPasswordForm';
import SelectServiceForm from '@/components/SelectServiceForm/SelectServiceForm';
import SignInForm from '@/components/SignInForm/SignInForm';
import SignUpForm from '@/components/SignUpForm/SignUpForm';
import TimeOutAlert from '@/components/TimeOutAlert/TimeOutAlert';
import UserPortal from '@/pages/UserPortal/UserPortal.vue';
import '@/pages/UserPortal/polteq.scss';

const app = createApp(UserPortal);

app.use(vuetify);
app.use(i18n);
app.use(router);
app.use(createPinia());

app
  .component('ActivateForm', ActivateForm)
  .component('ChangePasswordForm', ChangePasswordForm)
  .component('ForgotPasswordForm', ForgotPasswordForm)
  .component('IDOverview', IDOverview)
  .component('PersonalProfile', PersonalProfile)
  .component('PolteqButton', PolteqButton)
  .component('PolteqTextField', PolteqTextField)
  .component('ResetPasswordForm', ResetPasswordForm)
  .component('SelectServiceForm', SelectServiceForm)
  .component('SignInForm', SignInForm)
  .component('SignUpForm', SignUpForm)
  .component('TimeOutAlert', TimeOutAlert);
app.mount('#app');
